export var roundToTwoDecimal = function (input) { return +input.toFixed(2); };
export var convertPercentageToDecimal = function (percentage) {
    return percentage / 100;
};
